// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "af1cc8c27e617ec99bf38545d2fb6c89a9ff8328/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};